import { is } from "date-fns/locale";
import { multipleOperationOff, multipleOperationOn, singleOperationOff, singleOperationOn, videoModeOffColor, videoModeOffGray } from "../../../../asset";

export const singlePageStudyReport = (reportData, chart: HTMLCanvasElement, isElementBased: boolean) => {
    const a = window.open('', '', 'width:600;height:600;');
    a.document.write('<html><body>');
    const style = document.createElement('style')
    style.textContent = `
            @page { 
                size: A4 landscape;
            }
            body {
                padding: 10px;
                font-family: sans-serif;
                color: #333;
                vertical-align: middle;
            }
            h2 {
                margin: 0px 0px 10px 0px;
                text-align: center;
                color: #333;
            }
            .table-rwd {
                width: 100%;
                font-size: 0.85em;
                color: #666;
                margin-left: auto;
                margin-right: auto;
                min-width: 980px;
            }
            .table-rwd td,
            .table-rwd th {
                padding: 0.5em;
            }
            .table-rwd th {
                background: var(--color-main);
                color: #fff;
                font-weight: normal;
                text-align: right;
            }
            .table-rwd td {
                text-align: left;
            }
            .table-rwd tr:first-child td:first-child {
                color: white;
                background: #333333;
            }
            .table-rwd tr:first-child td:nth-child(2) {
                background: #f4f4f4;
            }
            .table-rwd tr td:nth-child(2n) {
                font-weight: bold;
                text-transform: uppercase;
            }
            .table-container {
                width: 100%;
                margin:0px;
                border: 1px solid rgba(181, 213, 144, 0.5);
            }
            .table-rwd td img {
                max-width: 17px;
                vertical-align: middle;
                margin-right: 11px;
            }
            .table-rwd th:first-child {
                width: 8em;
            }
            .table-rwd tr:first-child{
                border-bottom: 1px solid rgba(181, 213, 144, 0.5);
            }
            .table-rwd tr:first-child td {
                text-align: center;
            }
            .table-rwd tr:first-child p {
                text-transform: uppercase;
                font-weight: 500;
            }
            .table-rwd tr:first-child div {
                font-weight: bold;
                font-size: 40px;
            }
            .table-rwd tr:first-child div sub{
                font-size: 15px;
                vertical-align: baseline;
            }
            .table-rwd tr:nth-child(2) td:first-child {
                box-shadow: 0 -2.7em 0 -6px var(--color-main),
                -6px -2.7em 0 -6px var(--color-main);
            }
            .legend {
                text-align: center;
                padding: 14px;
                font-size: 13px;
            }
            .legend span {
                display: inline-block;
                margin-right: 11px;
            }
            .legend span sub {
                display: inline-block;
                margin-right: 4px;
                padding: 6px 16px;
                background: #eee;
                border-width: 1px;
                border-style: solid;
            }
            .tactTime sub {
                border-color: red;
            }
            .pitchTime sub {
                border-color: blue;
            }
            `;
    a.document.head.appendChild(style)
    a.document.write('</head>');
    a.document.write('<body>');
    a.document.write('<h2>YAMAZUMI STUDY REPORT</h2>');
    a.document.write(`
        <div class="table-container">
            <table class="table-rwd">
                <tr>
                    <td colspan="5">
                        <p>TOTAL ELAPSED TIME</p>
                        <div>${reportData.totalElapsedTime?.min}<sub>MIN</sub> ${reportData.totalElapsedTime?.sec}<sub>SEC</sub></div>
                    </td>
                    <td colspan="5">
                        <p>TOTAL STUDY</p>
                        <div>${reportData.categories?.length || 0}<sub>TM</sub></div>
                    </td>
                </tr>
                <tr>
                    <td>MODULE</td>
                    <td>${reportData.module}</td>
                    <td>ELEMENT MODE</td>
                    <td>${reportData.isElementBased ? `<img src=${videoModeOffColor} />` : `<img src=${videoModeOffGray} />`}</td>
                    <td>STYLE</td>
                    <td>${reportData.style}</td>
                    <td>OPERATION MODE</td>
                    <td>
                        ${!reportData.isMultipleOperation ? `<img src=${singleOperationOn} />` : `<img src=${singleOperationOff} />`}
                        ${reportData.isMultipleOperation ? `<img src=${multipleOperationOn} />` : `<img src=${multipleOperationOff} />`}
                    </td>
                    <td>VERSION</td>
                    <td>${reportData.version}</td>
                </tr>
                <tr>
                    <td>TOTAL SMV</td>
                    <td>${reportData.totalSMV}</td>
                    <td>PACEMAKER CT</td>
                    <td>${reportData.phaseMakerCT}</td>
                    <td>TACT TIME</td>
                    <td>${reportData.tactTime}</td>
                    <td>POTENTIAL PC</td>
                    <td>${reportData.potentialPC}</td>
                    <td>OPR.IMPROVED</td>
                    <td>${reportData.noOfOperationImproved}</td>
                </tr>
                <tr>
                    <td>BALANCING LOSS</td>
                    <td>${reportData.balancingLoss}</td>
                    <td>EFFICIENCY</td>
                    <td>${reportData.moduleEfficiency}</td>
                    <td>PSD</td>
                    <td>${reportData.psd}</td>
                    <td>YAMAZUMI TYPE</td>
                    <td>${reportData.yamazumiType}</td>
                    <td>CREATED AT</td>
                    <td>${reportData.createdAt}</td>
                </tr>
            </table>
        </div>
        ${!isElementBased ?
            `<div class="legend">
            <span class="tactTime">
                <sub></sub>
                Tact Time
            </span>
            <span class="pitchTime">
                <sub></sub>
                Pitch Time
            </span>
        </div>`: ''}
        `);
    // const chart = document.getElementsByTagName("canvas")[0];
    const newCanvas = document.createElement('canvas');
    const context = newCanvas.getContext('2d');
    newCanvas.width = chart.width;
    newCanvas.height = chart.height;
    context.drawImage(chart, 0, 0);
    a.document.body.appendChild(newCanvas);
    a.document.write('</body></html>');
    a.document.close();
    a.print();
}